import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Checkbox, Spin, Icon } from 'antd'
import './tree.css'

export class Tree extends Component {

  constructor(props) {
    super(props)

    this.state = {
      active: null,
      list: [{ level: 'root', data: props.data }],
      ids: props.defaultIds ? props.defaultIds : [],
      loadingKey: null,
    }

  }

  componentDidMount() {
    const { defaultIds } = this.props
    if (defaultIds && defaultIds.length > 0) {
      const { list } = this.state
      this.setState({
        list: list.map(r => ({
          ...r,
          data: r.data.map(item => {
            if (defaultIds.includes(item.key)) {
              const allChilds = item.allChilds || []
              const allChildsSelected = allChilds.every(child => defaultIds.includes(child.id))
              return { ...item, checked: true, indeterminate: !allChildsSelected }
            }
            return item
          })
        }))
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {

    const { data, allFoldersChecked, allFoldersCheckedBySwitch, defaultIds } = this.props
    const { list } = this.state
    if (prevProps.data !== data) {
      const { ids } = this.state
      this.setState({
        list: [{ level: 'root', data: data.map(item => {
          if (ids.includes(item.key)) {
            const allChildsSelected = item.allChilds && item.allChilds.every(child => ids.includes(child.id))
            return { ...item, checked: true, indeterminate: !allChildsSelected }
          }
          return item
        }) }],
      })
    }

    if (defaultIds && (!this.isDefaultIdsEquals(defaultIds, prevProps.defaultIds || []))) {

      this.setState(prevState => ({
        ids: defaultIds,
        list: [...prevState.list.map(r => {
          return {
            ...r,
            data: r.data.map(item => {
              if (!defaultIds.includes(item.key)) return item
              const allChilds = item.allChilds || []
              const allChildsSelected = allChilds.every(child => defaultIds.includes(child.id))
              return { ...item, checked: true, indeterminate: !allChildsSelected }
            }),
          }
        }),]
      }))
    }

    if (prevProps.allFoldersChecked !== allFoldersChecked) {

      if (allFoldersChecked) {
        let tempIds = []

        list[0].data.forEach(item => {
          tempIds = this.handleIds(tempIds, item, 'ADD')
        })
        const checkedList = this.changeAllFoldersCheckStatus(list, true)
        this.setState({ ids: tempIds, list: checkedList }, this.handleStoreValues)
      } else if (allFoldersCheckedBySwitch) {

        const uncheckedList = this.changeAllFoldersCheckStatus(list, false)
        this.setState({ ids: [], list: uncheckedList }, this.handleStoreValues)

      }
    }
  }

  isDefaultIdsEquals = (defaultIds, prevDefaultsIds) => {

    if (prevDefaultsIds.length !== defaultIds.length)
      return false

    return defaultIds.every((currentId, index) => currentId === prevDefaultsIds[index])


  }
  changeAllFoldersCheckStatus = (list, newCheckStatus) => {
    return list.map(l => {
      return {
        ...l,
        data: l.data.map(folder => { return { ...folder, checked: newCheckStatus, indeterminate: false } })
      }
    })

  }
  handleOnChange = (e, item) => {
    const { active } = this.state
    let { list, ids } = this.state
    const { children } = item
    const activeRoot = this.handleGetActiveRoot(item)


    if (!active || active._id !== activeRoot._id) {
      list = [...list.filter(r => r.level === 'root')]
    }

    if (e.target.checked) {
      // OBTIENE HIJOS
      const result = this.handleAddListByEveryChildren(children, item.key, true)

      if (active && active._id === activeRoot._id && list.length > item.allParents.length) {
        list = list.slice(0, item.allParents.length)
      }

      // MERGE
      let tempData = [...list.map(r => {
        return {
          ...r,
          data: r.data.map(i => {
            return i.key === item.key
              ? { ...i, checked: true }
              : { ...i }
          })
        }
      }), ...result]

      let tempIds = this.handleIds(ids, item, 'ADD')


      tempData = this.handleConsolidate(tempIds, tempData, true)

      this.setState({
        active: activeRoot,
        ids: tempIds,
        list: [...tempData.map(r => {
          return {
            ...r,
            data: r.data.map(r => {
              return tempIds.includes(r.key) && this.handleCheckAllChilds(r, tempIds)
                ? { ...r, checked: true, indeterminate: false }
                : tempIds.includes(r.key) && !this.handleCheckAllChilds(r, tempIds)
                  ? { ...r, indeterminate: true }
                  : { ...r }
            }),
          }
        }),]
      }, () => this.handleStoreValues())
    } else {
      let remove = false
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list[i].data.length; j++) {
          if (list[i].data[j].key === item.key) {
            remove = true
          }
        }
        if (remove) list.splice(i + 1, list.length)
      }

      let tempData = [...list.map(r => {
        return {
          ...r,
          data: r.data.map(i => {
            return i.key === item.key
              ? { ...i, checked: false }
              : { ...i }
          })
        }
      })]

      let tempIds = this.handleIds(ids, item, 'REMOVE')

      tempData = this.handleConsolidate(tempIds, tempData, false)

      this.setState({
        active: activeRoot,
        ids: tempIds,
        list: tempData
      }, () => this.handleStoreValues())
    }
  }

  handleConsolidate = (ids, data, status) => {
    return [...data.map(r => {
      return {
        ...r,
        data: r.data.map(i => {
          if (i.checked) {
            const totalChildren = i.allChilds.length
            const childSelected = i.allChilds.filter(x => ids.includes(x.id)).length


            return totalChildren === childSelected
              ? { ...i, checked: true, indeterminate: false }
              : { ...i, indeterminate: true }
          } else {
            return { ...i }
          }

        })
      }
    })]
  }

  handleShowContent = async (item) => {
    const { onLoadChildren } = this.props

    // Lazy load children if not yet loaded
    if (item.hasChildren && item.children.length === 0 && onLoadChildren) {
      this.setState({ loadingKey: item.key })
      try {
        const loadedChildren = await onLoadChildren(item)
        item = { ...item, children: loadedChildren, hasChildren: false }
        // Inject into current list so future clicks are instant
        this.setState(prev => ({
          loadingKey: null,
          list: prev.list.map(level => ({
            ...level,
            data: level.data.map(d => d.key === item.key ? item : d)
          }))
        }), () => this.doShowContent(item))
      } catch (e) {
        this.setState({ loadingKey: null })
      }
      return
    }

    this.doShowContent(item)
  }

  doShowContent = item => {
    const { active, ids } = this.state
    const { children } = item
    let { list } = this.state
    const activeRoot = this.handleGetActiveRoot(item)

    if (!active || active._id !== activeRoot._id) {
      list = [...list.filter(r => r.level === 'root')]
    }

    let remove = false
    for (let i = 0; i < list.length; i++) {
      for (let j = 0; j < list[i].data.length; j++) {
        if (list[i].data[j].key === item.key) {
          remove = true
        }
      }
      if (remove) list.splice(i + 1, list.length)
    }

    const result = this.handleExploreList(children, ids)
    this.setState({
      active: activeRoot,
      list: [...list.map(r => {
        return {
          ...r,
          data: r.data.map(r => {
            return ids.includes(r.key) && this.handleCheckAllChilds(r, ids)
              ? { ...r, checked: true }
              : ids.includes(r.key) && !this.handleCheckAllChilds(r, ids)
                ? { ...r, indeterminate: true }
                : { ...r }
          }),
        }
      }), ...result]
    })
  }

  /**
   * 
   * @param {*} ids list
   * @param {*} item object
   * @param {*} action string
   * 
   * Agrega o elimina los ids de las carpetas y subcarpetas según corresponde
   */
  handleIds = (ids, item, action) => {

    if (action === 'ADD') {
      ids = !ids.includes(item.key)
        ? [...ids, item.key]
        : [...ids]

      item.allParents.forEach(parent => {
        ids = parent.type !== "root" && !ids.includes(parent._id)
          ? [...ids, parent._id]
          : [...ids]
      })

      if (item.children.length > 0) {
        item.children.forEach(r => {
          ids = !ids.includes(r.key)
            ? this.handleIds(ids, r, action)
            : [...ids]
        })
      }
    } else {
      ids = ids.filter(r => r !== item.key)
      if (item.children.length > 0) {
        item.children.forEach(r => {
          ids = this.handleIds(ids, r, action)
        })
      }
    }

    return ids

  }

  /**
   * Retorna array con estructura para renderizar árbol según status
   * @param {*} data array
   * @param {*} status boolean
   */
  handleAddListByEveryChildren = (data, itemKey, status) => {
    let result = [{
      level: 'no_root',
      itemKey,
      data: data.map(r => {
        return {
          ...r,
          checked: status
        }
      })
    }]

    if (result[0].data.length === 1 && result[0].data[0].children.length > 0) {
      const temp = this.handleAddListByEveryChildren(result[0].data[0].children, itemKey, status)
      result = [...result, ...temp]
    }
    return result
  }

  handleCheckAllChildren = (item, ids) => {
    let totalChildren = item.children.length
    let found = 0

    if (totalChildren > 0) {
      item.children.forEach(child => {
        if (ids.includes(child.key)) {
          found++
        }
      })

      return totalChildren === found
    } else {
      return true
    }
  }


  handleCheckAllChilds = (item, ids) => {
    let totalChilds = item.allChilds.length
    let found = 0

    if (totalChilds > 0) {
      item.allChilds.forEach(child => {
        if (ids.includes(child.id)) {
          found++
        }
      })

      return totalChilds === found
    } else {
      return true
    }
  }
  handleExploreList = (data, ids) => {
    let result = [{
      level: 'no_root',
      data: data.map(r => {
        return ids.includes(r.key) && this.handleCheckAllChilds(r, ids)
          ? { ...r, checked: true }
          : ids.includes(r.key) && !this.handleCheckAllChilds(r, ids)
            ? { ...r, indeterminate: true }
            : { ...r }
      })
    }]

    // if (result[0].data.length > 0 && result[0].data[0].children.length > 0) {
    //   const temp = this.handleExploreList(result[0].data[0].children, ids)
    //   result = [...result, ...temp]
    // }
    return result
  }

  handleStoreValues = () => {
    this.props.handleSelectedFolders(this.state.ids)
  }

  /**
   * Retorna el root seleccionado
   * @param {*} item object
   */
  handleGetActiveRoot = item => {
    return item.allParents[1]
      ? { _id: item.allParents[1]._id, name: item.allParents[1].name }
      : { _id: item.key, name: item.title }
  }

  render() {
    const { list, loadingKey } = this.state

    return (
      <div className="bunkey-box-tree">
        <div className="bunkey-tree-container">
          {list.map((r, i) =>
            <ul key={i} className="bunkey-tree-ul">
              {r.data.map((item, j) => <li key={j} className="bunkey-tree-li">
                <Checkbox indeterminate={item.indeterminate} onChange={(e) => this.handleOnChange(e, item)} checked={item.checked} />
                <div className={item.checked ? `bunkey-tree-folder-name-active` : `bunkey-tree-folder-name`} >
                  <span className="bunkey-tree-li-span" onClick={() => loadingKey !== item.key && this.handleShowContent(item)} style={{ cursor: loadingKey === item.key ? 'default' : 'pointer' }}>
                    {item.title}
                    {loadingKey === item.key
                      ? <Spin size="small" style={{ marginLeft: 8 }} />
                      : item.hasChildren && item.children.length === 0
                        ? <Icon type="right" style={{ marginLeft: 6, fontSize: 10, color: '#aaa' }} />
                        : null
                    }
                  </span>
                </div>
              </li>)}
            </ul>)}
        </div>
      </div>

    )
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Tree)))